import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-iframe-modal",
    templateUrl: "./iframe-modal.component.html",
    styleUrls: ["./iframe-modal.component.css"],
})
export class IframeModalComponent {
    constructor(
        public dialogRef: MatDialogRef<IframeModalComponent>,
        @Inject(MAT_DIALOG_DATA) public iframeSrc: any
    ) {
        dialogRef.disableClose = true;
    }

    close() {
        this.dialogRef.close();
    }
}
